import React, { useEffect } from "react";
import { Button, Row, Col, ListGroup, Image, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Message from "../components/Message";
import Loader from "../components/Loader";
import { getOrderDetails } from "../actions/orderActions";
import {
  ORDER_PAY_RESET,
  ORDER_DELIVER_RESET,
} from "../constants/orderConstants";



function OrderScreen({ match, history }) {
  const orderId = match.params.id;
  const dispatch = useDispatch();

  const orderDetails = useSelector((state) => state.orderDetails);
  const { order, error, loading } = orderDetails;

  const orderPay = useSelector((state) => state.orderPay);
  const { success: successPay } = orderPay;

  const orderDeliver = useSelector((state) => state.orderDeliver);
  const { success: successDeliver } = orderDeliver;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  

  const modifyBoxShadowForPdf = (add) => {
    const element = document.getElementById("print-content-row");
    if (element) {
      element.style.boxShadow = add ? "0 0 10px #007bff" : "none";
    }
  };

  const printOrderDetails = () => {
    const input = document.getElementById("print-content-row");
    if (input) {
      //     // Remove box shadow before PDF generation
      modifyBoxShadowForPdf(false);
        Promise.all(
            Array.from(input.getElementsByTagName("img")).map(img => {
                return new Promise(resolve => {
                    if (img.complete && img.naturalHeight !== 0) {
                        resolve();
                    } else {
                        const src = img.src;
                        img.onload = resolve;
                        img.onerror = () => {
                            console.log("Failed to load image", img.src);
                            img.src = "https://via.placeholder.com/150"; // Fallback image
                            resolve(); // Resolve to avoid blocking the PDF generation
                        };
                        // Append a timestamp to the image URL to prevent caching issues
                        img.src = `${src.includes('?') ? src + '&' : src + '?'}cacheBust=${new Date().getTime()}`;
                    }
                });
            })
        ).then(() => {
            html2canvas(input, {
                useCORS: true,
                allowTaint: false,
                logging: true,
                onclone: document => {
                    document.getElementById("print-content-row").style.boxShadow = 'none';
                }
            }).then(canvas => {
                const imgData = canvas.toDataURL("image/png");
                const pdf = new jsPDF({ orientation: "portrait" });
                const imgProps = pdf.getImageProperties(imgData);
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
                pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
                window.open(pdf.output("bloburl"), "_blank");
            });
        });
    }
};


  const downloadPdfDocument = () => {
    const input = document.getElementById("print-content-row");
    if (input) {
      // Remove box shadow before PDF generation
      modifyBoxShadowForPdf(false);

      html2canvas(input, {
          useCORS: true,
          allowTaint: false

        }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF({
          orientation: "portrait",
        });
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`download-${new Date().toISOString()}.pdf`);

        // Add box shadow back after PDF generation
        modifyBoxShadowForPdf(true);
      });
    }
  };
  const handleEmailProcess = () => {
    // First, invoke the PDF generation and download (assuming you have this function)
    downloadPdfDocument();

    // Then, prompt the user
    alert(
      "Your PDF has been downloaded. Please attach it to your email manually. Click 'OK' to open your email client."
    );

    // Optionally, open the default email client with pre-filled details (without attachment)
    const mailToLink = `mailto:?subject=Order Details&body=Please attach the downloaded PDF to this email.`;
    window.open(mailToLink, "_blank");
  };

  if (!loading && !error) {
    order.itemsPrice = order.orderItems
      .reduce((acc, item) => acc + item.price * item.qty, 0)
      .toFixed(2);
  }

  useEffect(() => {
    if (!userInfo) {
      history.push("/login");
    }

    if (
      !order ||
      successPay ||
      order._id !== Number(orderId) ||
      successDeliver
    ) {
      dispatch({ type: ORDER_PAY_RESET });
      dispatch({ type: ORDER_DELIVER_RESET });

      dispatch(getOrderDetails(orderId));
    }
  }, [dispatch, order, orderId, successPay, successDeliver, history, userInfo]);

  // const handlePrint = () => {
  //   window.print();
  // };
  

  return loading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error}</Message>
  ) : (
    <div >
      {/* CSS for printing */}
      <style>
        {`
          @media print {
            html, body {
              width: 8.5in !important;
              height: 11in !important;
              margin: 0 !important;
              padding: 0 !important;
              box-shadow: none !important;
              overflow: hidden !important;
              background-color: red !important; // Red background for the entire page
              color: black !important;
            }
            .print-content-row {
              box-shadow: none !important;
              max-width: 100% !important;
              overflow: hidden !important;
              page-break-after: auto !important;
              background-color: blue !important; // Blue background for content rows
              color: yellow !important; // Yellow text for visibility
              border: none !important; // Remove borders
            }
            img {
              max-width: 100% !important;
            }
            .hidden-print, .buttonAdd {
              display: none !important; // Ensure buttons do not display
            }
          }
          .print-content-row {
            padding: -100px !important;
            margin: -100px !important;
            border-radius: 10px !important;

          }
        `}
      </style>
      <Button
        type="button"
        className="buttonAdd hidden-print"
        onClick={() => history.goBack()}
      >
        Go Back
      </Button>
      <div
        style={{
          textAlign: "right",
          padding: "20px",
        }}
      >
        <Button type="button" className="buttonAdd hidden-print" 
        onClick={printOrderDetails}
        // onClick={handlePrint}
        >
          Print
        </Button>{" "}
        <Button
          type="button"
          className="buttonAdd hidden-print"
          onClick={downloadPdfDocument}
        >
          Download
        </Button>{" "}
        <Button
          type="button"
          className="buttonAdd hidden-print"
          onClick={handleEmailProcess}
        >
          Email
        </Button>
      </div>
      <Row
        id="print-content-row"
        
        style={{
          padding: "20px",
          margin: "20px",
          borderRadius: "10px",
          boxShadow: "0 0 10px #007bff ",
        }}
      >
        <Col
          md={3}
          className="offset-md-9 "
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
            flexDirection: "column",
          }}
        >
          <ListGroup.Item>
            <h1>Quote {order.quote_number}</h1>
            {/* add date */}
            <h4>Date: {order.createdAt.substring(0, 10)}</h4>
            <p className="text-center center mt-0">valid until end of month</p>
          </ListGroup.Item>
        </Col>

        <Col
          md={9}
          style={{
            display: "flex",
            alignItems: "start",
            justifyContent: "start",
            flexDirection: "column",
            marginTop: "-200px",
          }}
        >
          <ListGroup variant="flush">
            <ListGroup.Item>
              <span
                style={{
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "start",
                  flexDirection: "column",
                  fontSize: "2rem",
                }}
              >
                <img
                  src={userInfo.logo}
                  style={{ width: "150px", display: "block" }}
                  alt="Dealer Logo"
                />
                <strong>{userInfo.business_name}</strong>
              </span>
              <strong>Phone:</strong> {userInfo.phone} <strong>| Email:</strong>{" "}
              {userInfo.email} <strong>| Website:</strong> {userInfo.website}
              <p>
                <strong>Address: </strong>
                {userInfo.address}, {userInfo.city}, {userInfo.state},{" "}
                {"  "}
                {userInfo.postalCode},{"  "}
                {userInfo.country}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Client Address</h2>
              <p>
                <strong>Name: </strong> {order.shippingAddress.first_name}
              </p>
              <p>
                <strong>Email: </strong>
                {order.shippingAddress.email}
              </p>
              <p>
                <strong>Shipping: </strong>
                {order.shippingAddress.address}, {order.shippingAddress.city}
                {"  "}
                {order.shippingAddress.postalCode},{"  "}
                {order.shippingAddress.country}
              </p>
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Image
            src={order.imageURL}
            style={{
              width: "300px",
              // height: "300px",
            }}
            alt={order.product_name}
          />
        </Col>

        <Col md={12}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <span
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                    // flexDirection: "column",
                    fontSize: "2rem",
                  }}
                >
                  You're Saving!
                  {/* add blank space */}
                  <span style={{ width: "30px" }}></span>
                  <strong>
                    $
                    {parseFloat(order.you_are_saving)
                      ? parseFloat(order.you_are_saving).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      : "0.00"}
                  </strong>
                </span>
              </ListGroup.Item>
              <ListGroup.Item>
                <table className="table table-bordered">
                  <thead>
                    <tr
                      style={{
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      <th
                        style={{
                          width: "70%",
                        }}
                      >
                        Description
                      </th>
                      <th
                        style={{
                          width: "10%",
                        }}
                      >
                        Quantity
                      </th>

                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody
                    style={{
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    <tr>
                      <td>
                        Tractor: <strong>{order.t_list_description}</strong>
                      </td>
                      <td>1</td>

                      <td>
                        $
                        {parseFloat(order.t_MSRP)
                          ? parseFloat(order.t_MSRP).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Attachment: <strong>{order.a_list_description}</strong>
                      </td>
                      <td>{order.a_qty}</td>

                      <td>
                        $
                        {parseFloat(order.a_MSRP)
                          ? parseFloat(order.a_MSRP).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Options: <strong>{order.o_list_description}</strong>
                      </td>
                      <td>{order.o_qty}</td>
                      <td>
                        $
                        {parseFloat(order.o_MSRP)
                          ? parseFloat(order.o_MSRP).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Subtotal</strong>
                      </td>
                      <td></td>

                      <td>
                        <strong>
                          {" "}
                          ${/* sum of t_MSRP + a_MSRP + o_MSRP */}
                          {parseFloat(order.t_MSRP) +
                          parseFloat(order.a_MSRP) +
                          parseFloat(order.o_MSRP)
                            ? (
                                parseFloat(order.t_MSRP) +
                                parseFloat(order.a_MSRP) +
                                parseFloat(order.o_MSRP)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "0.00"}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>Set up & PDI</td>
                      <td>-</td>
                      <td>
                        $
                        {parseFloat(order.setup_pdi)
                          ? parseFloat(order.setup_pdi).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Destination Charge</td>
                      <td>-</td>
                      <td>
                        $
                        {parseFloat(order.destination_charge)
                          ? parseFloat(order.destination_charge).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Extra Charges: {order.description_additional_charges}
                      </td>
                      <td>-</td>
                      <td>
                        $
                        {parseFloat(order.additional_charges)
                          ? parseFloat(order.additional_charges).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Adjusted Sales Price</strong>
                      </td>
                      <td>-</td>
                      <td>
                        <strong>
                          $
                          {parseFloat(order.adjusted_sales_price)
                            ? parseFloat(
                                order.adjusted_sales_price
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "0.00"}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td>Proc/Doc Fee</td>
                      <td>-</td>
                      <td>
                        $
                        {parseFloat(order.doc_fee)
                          ? parseFloat(order.doc_fee).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td>Delivery</td>
                      <td>-</td>
                      <td>
                        $
                        {parseFloat(order.delivery)
                          ? parseFloat(order.delivery).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"}
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        Best Financing Option:{" "}
                        <strong>{order.financing_description}</strong>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        Total of {order.term} payments:
                        <strong>
                          {" "}
                          $
                          {parseFloat(order.total_financed)
                            ? parseFloat(order.total_financed).toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                            : "0.00"}
                        </strong>{" "}
                        for Total of Interest:{" "}
                        <strong>
                          $
                          {parseFloat(order.total_interest)
                            ? parseFloat(order.total_interest).toLocaleString(
                                undefined,
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )
                            : "0.00"}
                        </strong>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
        <Col md={3} className="offset-md-9 mt-3 mb-5" style={{}}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Down Payt:</strong>
                  </Col>
                  <Col>
                    $
                    {parseFloat(order.down_payment)
                      ? parseFloat(order.down_payment).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      : "0.00"}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Trade In:</strong>
                  </Col>
                  <Col>
                    $
                    {parseFloat(order.trade_in)
                      ? parseFloat(order.trade_in).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col
                    style={{
                      fontSize: "0.9rem",
                    }}
                  >
                    <strong>Dealer Discount:</strong>
                  </Col>
                  <Col>
                    $
                    {parseFloat(order.dealer_discount)
                      ? parseFloat(order.dealer_discount).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      : "0.00"}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Total Discount:</strong>
                  </Col>
                  <Col>
                    $
                    {parseFloat(order.you_are_saving)
                      ? parseFloat(order.you_are_saving).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )
                      : "0.00"}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>
                      Tax (
                      {parseFloat(
                        order.tax_percent
                          ? parseFloat(order.tax_percent).toLocaleString(
                              undefined,
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          : "0.00"
                      )}
                      %):
                    </strong>
                  </Col>
                  <Col>
                    $
                    {parseFloat(order.tax)
                      ? parseFloat(order.tax).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>
                    <strong>Total Due:</strong>
                  </Col>
                  <Col
                    style={{
                      fontSize: "1.3rem",
                    }}
                  >
                    $
                    {parseFloat(order.total_cost)
                      ? parseFloat(order.total_cost).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })
                      : "0.00"}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>

        <Col md={12} className="">
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <span>
                  <strong>Terms and Conditions</strong>
                </span>
                <p
                  style={{
                    textAlign: "justify",
                    fontSize: "0.5rem",
                  }}
                >
                  By using this Quote Web App ("Start Blue App") for LS Tractor
                  USA, you acknowledge and agree to the following terms and
                  conditions.
                  <strong>Quote Validity:</strong> Quotes generated by the App are valid until the end of the month from the date of issuance unless otherwise specified. Prices and availability are subject to change without notice.
                  <strong>Non-Binding:</strong> All quotes are non-binding and
                  are subject to final approval by LS Tractor USA. The App does not create any legal
                  obligation for LS Tractor USA to sell products at the quoted
                  prices or under the quoted terms.
                  <strong>Intellectual Property:</strong> The content and
                  information on this App, including but not limited to text,
                  graphics, and user interface, are protected by copyright,
                  trademarks, or other proprietary rights and laws. Use of this
                  content without the express permission of the rightful owner
                  is strictly prohibited.
                  <strong>Accuracy of Information:</strong> While we strive to
                  provide accurate and up-to-date information, we cannot
                  guarantee that all information provided by the App will be
                  accurate at all times. Users are encouraged to verify the
                  final quote details with LS Tractor USA.
                  <strong>Limitation of Liability:</strong> In no event shall LS
                  Tractor USA, its affiliates, officers, directors, employees,
                  or agents be liable for any direct, indirect, incidental,
                  special, or consequential damages arising out of or in
                  connection with your use of the App or any quote generated by
                  the App.
                  <strong>Amendments:</strong> LS Tractor USA reserves the right
                  to modify these terms and conditions at any time without prior
                  notice. Your continued use of the App after any such changes
                  constitutes your acceptance of the new terms and conditions.
                  <strong>Governing Law:</strong> These terms and conditions
                  shall be governed by and construed in accordance with the laws
                  of the state in which LS Tractor USA operates, without giving
                  effect to any principles of conflicts of law.
                  <strong>Contact Information:</strong> For any questions or
                  concerns regarding these terms and conditions, please contact
                  LS Tractor USA through the App's contact form or at the
                  provided customer service contact information.
                </p>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <span
            style={{
              color: "#007bff",
            }}
          >
            <strong>Start Blue. Stay Blue. | LS Tractor USA</strong>
          </span>
        </Col>
      </Row>
    </div>
  );
}

export default OrderScreen;
